import { render } from "./FeaturedProducts.vue?vue&type=template&id=5695eef4"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"

import "./FeaturedProducts.vue?vue&type=style&index=0&id=5695eef4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__